import {BasicSymbol, SymbolStates} from "./BasicSymbol";
import {Reel} from "../Reel";
import {gsap} from "gsap";
import {XwaysHoarder2} from "../../XwaysHoarder2";
import {XwaysHoarder2Statics} from "../../XwaysHoarder2Statics";
import {XwaysHoarder2GameAssets} from "../../XwaysHoarder2GameAssets";
import {SpineGSAPWrapper} from "../../utils/SpineGSAPWrapper";
import {SimpleReelModelSymbolPosition} from "../../../core/reel/simplereel/SimpleReelModel";
import {XwaysHoarder2Sound} from "../../sound/XwaysHoarder2Sound";


export class XSplitSymbol extends BasicSymbol {

    private wildSprite: PIXI.Sprite;
    private wildSpine: PIXI.spine.Spine;
    private _isWildRevealed: boolean;
    private mpTextContainer: PIXI.Container;
    private mpText: PIXI.BitmapText | null;
    private mpTextWhite: PIXI.BitmapText | null;
    private xsLockSpine: PIXI.spine.Spine;
    private xsLockSprite: PIXI.Sprite;


    constructor(symbolName: string, initState: SymbolStates, reel: Reel, symbolPosition: SimpleReelModelSymbolPosition, sizeAtStart: number) {
        super(symbolName, initState, reel, symbolPosition);
        this.symbolSize = sizeAtStart;
        this.symbolName = "XS";
        this.load();
        this.getStateAnimation(initState)
        if (XwaysHoarder2.model.isRestore) {
            if (XwaysHoarder2.model.isSuperFreespinStarting || XwaysHoarder2.model.isFreespinStarting) {
                if (XwaysHoarder2.model.data.reelsAfterCollapse[this.reel.id][this.symID] !== "XS") {
                    this.getStateAnimation(SymbolStates.REMOVED);
                }
            }
        }
    }


    public getStateAnimation(state: SymbolStates): gsap.core.Timeline {
        let tl: gsap.core.Timeline = gsap.timeline();
        switch (state) {
            case SymbolStates.SPIN:
                tl.add(() => {
                    this.state = state;
                }, 0);
                this.mainSprite.alpha = 1;
                this.setSpriteTexture("_spin");
                this.moveToNormalLayer();
                break;
            case SymbolStates.START_SPIN:
                tl.add(() => {
                    this.state = state;
                    this.mainSpine!.visible = false;
                }, 0);
                this.moveToNormalLayer();
                break;
            case SymbolStates.LANDING:
                tl.add(() => {
                    this.state = state;
                }, 0);
                tl.to(this.mainSprite, {alpha: 0, duration: 0.001}, 0);
                tl.to(this.mainSpine, {alpha: 1, duration: 0.001}, 0);
                tl.add(() => {
                    XwaysHoarder2Sound.playTrack(XwaysHoarder2Sound.XSPLIT_LAND);
                }, 0.005);
                tl.add(SpineGSAPWrapper.createTimelineForAnimation(this.mainSpine!, 0, "landAttention", false).timeScale(1.8), 0);
                tl.add(SpineGSAPWrapper.createTimelineForAnimation(this.mainSpine!, 0, "xSplit Idle", false));
                // tl.to(this.mainSprite, {alpha: 1, duration: 0.001});
                break;
            case SymbolStates.NO_WIN:
                tl.add(() => this.moveToNormalLayer());
                //tl.add(this.showNoWinOverlay(XwaysHoarder2Statics.noWinTint, 0.3, 0.75, PIXI.BLEND_MODES.MULTIPLY, false));
                break;
            case SymbolStates.WIN:
                tl.add(() => {
                    this.state = state;
                }, 0);
                tl.add(this.playWildAnimation());
                break;
            case SymbolStates.REVEAL://XS is revealed = Wild, helpful in conversion and restore
                tl.add(() => {
                    this.state = state;
                }, 0);
                tl.add(this.symbolConversionAnimation());
                break;
            case SymbolStates.REVERT:
                tl.add(() => {
                    this.state = state;
                });
                tl.add(this.wildToXSTransformAnim());
                break;
            case SymbolStates.STICKY:
                tl.add(() => {
                    this.state = state;
                    this.moveToStickyLayer();
                }, 0);
                tl.add(this.lockAnimation(), 0);
                break;
            case SymbolStates.START_SPLIT://end texture is of wild
                tl.add(() => {
                    this.state = state;
                });
                tl.add(this.startSplitAnimation());
                tl.add(this.getStateAnimation(SymbolStates.REVEAL));
                break;
            case SymbolStates.UNSTICKY:
                tl.add(() => {
                    this.state = state;
                    this.moveToNormalLayer();
                }, 0);
                tl.add(this.unlockXSAnimation(), 0);
                break;
            case SymbolStates.REMOVED:
                tl.add(() => {
                    this.state;
                    // this.wildSpine.state.setAnimation(0, "w_Idle", false);
                }, 0);
                this.mainSprite.alpha = 0;
                this.mainSpine!.alpha = 0;
                this.wildSpine.alpha = 1;
                this.moveToNormalOverLayer();
                break;
            case SymbolStates.WIN_TOGGLE:
                break;
            case SymbolStates.SPLIT: //only change sprite states
                this.isSplitted = true;
                tl.add(() => {
                    this.state = state;
                }, 0);
                tl.add(this.showSplitAnim());
                break;
            case SymbolStates.SCALED:
                break;
            default:
                tl.add(() => {
                    this.state = state;
                });
                this.mainSpine!.alpha = 1;
                this.mainSpine!.state.setAnimation(0, "xSplit Idle", false);
                this.mainSprite.alpha = 0;
                this.moveToNormalLayer();
        }
        return tl;
    }


    public setSpriteTexture(textureName: string = ""): void {
        if (textureName == "none") {
            this.mainSprite.texture = PIXI.Texture.EMPTY;
        } else {
            this.mainSprite.texture = XwaysHoarder2.assetLoader.getTextures(XwaysHoarder2GameAssets.getSymbolStateTexturePath(this.symbolName, textureName))[0];
        }
    }

    public hideXSSize(): gsap.core.Timeline {
        const hideTl: gsap.core.Timeline = gsap.timeline();
        if (this.symbolSize > 1) {
            hideTl.to(this.mpText!, {alpha: 0, duration: 0.25}, 0);
            hideTl.to(this.mpText!.scale, {x: 0, y: 0, duration: 0.25}, "<");
            hideTl.add(() => {
                this.symbolSize = 1;
                this.mpText!.text = "";
            }, ">");
        }

        return hideTl;
    }

    private lockAnimation(): gsap.core.Timeline {
        const xsLockTl: gsap.core.Timeline = gsap.timeline();
        xsLockTl.add(() => {
            this.xsLockSpine.visible = true;
        }, 0.005);
        xsLockTl.add(SpineGSAPWrapper.createTimelineForAnimation(this.xsLockSpine!, 0, "1x1_Lock", false).timeScale(2), 0);
        xsLockTl.add(this.hideXSSize());
        xsLockTl.add(() => {
            this.xsLockSprite.visible = true;
            this.xsLockSpine.visible = false;
        }, ">");
        this.isOldSym = true;

        return xsLockTl;
    }

    private unlockXSAnimation(): gsap.core.Timeline {
        const xsUnlckTL: gsap.core.Timeline = gsap.timeline();
        if (this.state === SymbolStates.STICKY) {
            xsUnlckTL.add(() => {
                this.xsLockSprite.visible = false;
                this.xsLockSpine.visible = true;
            }, 0.005);
            xsUnlckTL.add(SpineGSAPWrapper.createTimelineForAnimation(this.xsLockSpine, 0, "1x1_Off", false).timeScale(1), 0);
            xsUnlckTL.add(() => {
                this.xsLockSprite.visible = false;
                this.xsLockSpine.visible = false;
            }, ">")
        }
        return xsUnlckTL;
    }

    private load() {

        this.mpTextContainer = new PIXI.Container();
        this.mpTextContainer.name = "multipliercontainer";

        this.mainSprite.texture = XwaysHoarder2.assetLoader.getTextures(XwaysHoarder2GameAssets.getSymbolStateTexturePath(this.symbolName, ""))[0];
        this.mainSprite.name = "mainSprite";
        this.mainSprite.position.set(XwaysHoarder2Statics.symbolWidth * 0.5, XwaysHoarder2Statics.symbolHeight * 0.5);
        this.mainSprite.anchor.set(0.5, 0.5);
        this.mainSprite.alpha = 0;

        this.wildSprite = new PIXI.Sprite(XwaysHoarder2.assetLoader.getTextures(XwaysHoarder2GameAssets.getSymbolStateTexturePath(this.symbolName, "_revealed2"))[0]);
        this.wildSprite.name = "wildSprite";
        this.wildSprite.position.set(XwaysHoarder2Statics.symbolWidth * 0.5, XwaysHoarder2Statics.symbolHeight * 0.5);
        this.wildSprite.anchor.set(0.5, 0.5);
        this.wildSprite.visible = false;

        this._isWildRevealed = false;

        this.mpText = new PIXI.BitmapText("", {
            fontName: XwaysHoarder2GameAssets.NUMBERS_MULTIPLIER,
            fontSize: 32,
        });
        this.symbolSize > 1 ? this.mpText!.text = `${this.symbolSize}x` : this.mpText!.text = "";
        this.symbolSize > 1 ? this.mpText.alpha = 1 : this.mpText.alpha = 0;
        this.mpText.anchor = new PIXI.Point(0.5, 0.5);
        this.mpText.position.set(XwaysHoarder2Statics.symbolWidth - this.mpText.textWidth, XwaysHoarder2Statics.symbolHeight - this.mpText.textHeight);

        this.mpTextWhite = new PIXI.BitmapText("", {
            fontName: XwaysHoarder2GameAssets.MULTIPLIER_WHITE,
            fontSize: 32
        });
        this.mpTextWhite.anchor = new PIXI.Point(0.5, 0.5);
        this.mpTextWhite.alpha = 0;
        this.mpTextWhite.position.set(0, 0);
        this.mpText.addChild(this.mpTextWhite);
        this.mpTextContainer.addChild(this.mpText);

        this.mainSpriteContainer.addChild(this.wildSprite);
        this.setSpine();
        this.view.addChild(this.overlayContainer);
        this.view.addChild(this.mpTextContainer);

        this.visualHeightStatus = 200;
        this.setLockAssets();
        this.isSticky = false;
        this.isOldSym = false; //doesnt matter in restore
        this.symbolHeight = 1;//no of space it fills in terms of symbol count in a reel
        this.splitAnimOn = false;
        this.isSplitted = false;
        this.noWinOverlay = null; //create according to size

    }

    private setSpine(): void {
        this.mainSpine = new PIXI.spine.Spine(XwaysHoarder2.assetLoader.getSpineAsset(XwaysHoarder2GameAssets.XSPLIT));
        this.mainSpine.alpha = 0;
        this.mainSpine.name = "XSmainSpine";
        this.mainSpine.position.set(XwaysHoarder2Statics.symbolWidth * 0.5, XwaysHoarder2Statics.symbolHeight * 0.5);
        this.view.addChild(this.mainSpine);

        this.wildSpine = new PIXI.spine.Spine(XwaysHoarder2.assetLoader.getSpineAsset(XwaysHoarder2GameAssets.WILD));
        this.wildSpine.alpha = 0;
        this.wildSpine.name = "wildSpine";
        this.wildSpine.state.setAnimation(0, "w_Idle", false);
        this.wildSpine.position.set(XwaysHoarder2Statics.symbolWidth * 0.5, XwaysHoarder2Statics.symbolHeight * 0.5);
        this.view.addChild(this.wildSpine);


    }

    private playWildAnimation(): gsap.core.Timeline {
        const wildTl: gsap.core.Timeline = gsap.timeline();
        wildTl.add(() => {
            this.moveToWinLayer(this.view);
        }, 0);
        wildTl.add(SpineGSAPWrapper.createTimelineForAnimation(this.wildSpine, 0, "w_Win", false), 0);
        return wildTl;
    }

    private setLockAssets(): void {
        this.xsLockSpine = new PIXI.spine.Spine(XwaysHoarder2.assetLoader.getSpineAsset(XwaysHoarder2GameAssets.SYM_LOCK));
        this.xsLockSpine.visible = false;
        this.xsLockSpine.position.set(XwaysHoarder2Statics.symbolWidth * 0.5, XwaysHoarder2Statics.symbolHeight * 0.5);

        this.xsLockSprite = new PIXI.Sprite(XwaysHoarder2.assetLoader.getTextures(`lock_${this.visualHeightStatus}`)[0]);
        this.xsLockSprite.visible = false;
        this.xsLockSprite.anchor.set(0.5, 0.5);
        this.xsLockSprite.position.set(XwaysHoarder2Statics.symbolWidth * 0.5, XwaysHoarder2Statics.symbolHeight * 0.5);

        this.view.addChild(this.xsLockSprite, this.xsLockSpine);
    }

    private startSplitAnimation(): gsap.core.Timeline {
        const startsplitTL: gsap.core.Timeline = gsap.timeline();
        startsplitTL.add(SpineGSAPWrapper.createTimelineForAnimation(this.mainSpine!, 0, "split", false), 0);
        return startsplitTL;
    }

    private symbolConversionAnimation(): gsap.core.Timeline {
        const convertTl: gsap.core.Timeline = gsap.timeline();

        convertTl.add(SpineGSAPWrapper.createTimelineForAnimation(this.mainSpine!, 0, "xSplitTransform", false), 0);
        convertTl.to(this.wildSpine, {alpha: 1, duration: 0.005}, ">");
        convertTl.to(this.mainSpine, {alpha: 0, duration: 0.005}, ">");
        return convertTl;
    }

    private showSplitAnim(): gsap.core.Timeline {
        const symSplitTl: gsap.core.Timeline = gsap.timeline();
        this.isSplitted = true;
        symSplitTl.add(SpineGSAPWrapper.createTimelineForAnimation(this.wildSpine, 0, "w_Split", false));
        symSplitTl.add(this.multiplierUpdateAnimation(), "<");
        return symSplitTl;
    }

    private multiplierUpdateAnimation(): gsap.core.Timeline {
        const updateTL: gsap.core.Timeline = gsap.timeline();
        updateTL.add(() => {
            this.mpText!.alpha = 1;
        }, 0);
        updateTL.to(this.mpText!.scale, {x: 0.9, y: 0.9, duration: 0.333}, 0);
        updateTL.to(this.mpText!.scale, {x: 1.4, y: 1.4, duration: 0.033});
        updateTL.addLabel("showWhiteFont");
        updateTL.to(this.mpTextWhite, {alpha: 1, duration: 0.00001}, "showWhiteFont");
        updateTL.to(this.mpTextWhite!, {alpha: 0, duration: 0.165}, ">");
        updateTL.to([this.mpText!.scale, this.mpTextWhite!.scale], {x: 0.9, y: 0.9, duration: 0.132}, "showWhiteFont");
        updateTL.to([this.mpText!.scale, this.mpTextWhite!.scale], {x: 1, y: 1, duration: 0.033},">");

        updateTL.add(() => {
            this.symbolSize = this.symbolSize * 2;
            this.mpText!.text = `${this.symbolSize}x`;
            this.mpTextWhite!.text = `${this.symbolSize}x`;
            this.mpText!.anchor = new PIXI.Point(0.5, 0.5);
            this.mpText!.position.set(XwaysHoarder2Statics.symbolWidth - this.mpText!.textWidth, XwaysHoarder2Statics.symbolHeight - this.mpText!.textHeight);
            this.mpTextWhite!.position.set(0, 0);
            this.mpTextContainer.addChild(this.mpText!);
        }, "showWhiteFont");


        return updateTL;
    }

    private wildToXSTransformAnim(): gsap.core.Timeline {
        const rvertTl: gsap.core.Timeline = gsap.timeline();
        rvertTl.to(this.mainSpine, {alpha: 1, duration: 0.05}, 0);
        rvertTl.to(this.wildSpine, {alpha: 0, duration: 0.00}, ">");
        rvertTl.add(SpineGSAPWrapper.createTimelineForAnimation(this.mainSpine!, 0, "xSplitTransformBack", false), 0);
        rvertTl.add(this.hideXSSize(), "<");

        return rvertTl;
    }
}